import { render, staticRenderFns } from "./OfficialsList.vue?vue&type=template&id=40fbe7e2&"
import script from "./OfficialsList.vue?vue&type=script&lang=js&"
export * from "./OfficialsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports